import { MainLayout } from "@/layout/MainLayout";
import type { ReactNode } from "react";
import Forbidden from "@/pages/forbidden/Forbidden.tsx";

export default function PageForbidden(): ReactNode {
  return (
    <MainLayout>
      <Forbidden />
    </MainLayout>
  );
}
